export default __webpack_public_path__ + "static/media/3_nearshorit-image.715e1277.jpg";